import "./FixtureProblems.module.css";
import Header from "@/reusable_sections/Header";
import FixtureProblems from "./sections/FixtureProblems";
import FixtureTriage from "./sections/FixtureTriage";
import ContactArea from "./sections/ContactArea";
import Footer from "@/reusable_sections/Footer";
export default function FixtureProblemsPage() {
  return <div>
      <Header />
      <FixtureProblems />
      <FixtureTriage />
      <ContactArea />
      <Footer />
    </div>;
}